"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = void 0;

var _stylitas = require("@creditas/stylitas");

var Wrapper = _stylitas.styled.div(function (_ref) {
  var area = _ref.area;
  return (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    grid-area: ", ";\n  "])), area || 'unset');
});

exports.Wrapper = Wrapper;